'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n  box-shadow: ', ';\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: inherit;\n  outline: none;\n\n  &:focus, &:hover {\n    box-shadow: ', ';\n  }\n\n  &:active {\n    box-shadow: ', '\n  }\n'], ['\n  box-shadow: ', ';\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: inherit;\n  outline: none;\n\n  &:focus, &:hover {\n    box-shadow: ', ';\n  }\n\n  &:active {\n    box-shadow: ', '\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background: ', ';\n  color: white;\n  padding: 1em 2em;\n'], ['\n  background: ', ';\n  color: white;\n  padding: 1em 2em;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  background-color: inherit;\n  color: inherit;\n  padding: calc(1em - 1px) calc(2em - 1px);\n\n  &:focus, &:hover, &:active {\n    background: ', ';\n    color: white;\n  }\n'], ['\n  background-color: inherit;\n  color: inherit;\n  padding: calc(1em - 1px) calc(2em - 1px);\n\n  &:focus, &:hover, &:active {\n    background: ', ';\n    color: white;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  background-color: inherit;\n  background-image: ', ';\n  padding: 1px;\n  border-radius: 4px;\n  display: inline-block;\n'], ['\n  background-color: inherit;\n  background-image: ', ';\n  padding: 1px;\n  border-radius: 4px;\n  display: inline-block;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _sharedStyles = require('../sharedStyles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var Button = _styledComponents2.default.button(_templateObject, _sharedStyles.defaultBoxShadow, _sharedStyles.hoverBoxShadow, _sharedStyles.activeBoxShadow);

var PrimaryButton = (0, _styledComponents2.default)(Button)(_templateObject2, _sharedStyles.linearGradient);

var SecondaryButton = (0, _styledComponents2.default)(Button)(_templateObject3, _sharedStyles.linearGradient);

var SecondaryWrap = _styledComponents2.default.div(_templateObject4, _sharedStyles.linearGradient);

exports.default = function (props) {
  var children = props.children,
      secondary = props.secondary,
      rest = _objectWithoutProperties(props, ['children', 'secondary']);

  if (secondary) {
    return _react2.default.createElement(
      SecondaryWrap,
      null,
      _react2.default.createElement(
        SecondaryButton,
        rest,
        children
      )
    );
  }
  return _react2.default.createElement(
    PrimaryButton,
    rest,
    children
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../thicket/packages/thicket-elements/lib/Button/index.js
// module id = 89
// module chunks = 2